import { useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  Typography,
} from '@mui/material';

SelectGroupComponent.propTypes = {
  change: PropTypes.func,
  disableMargin: PropTypes.bool,
  error: PropTypes.bool,
  groups: PropTypes.instanceOf(Array).isRequired,
  helperText: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  text: PropTypes.any,
  value: PropTypes.any.isRequired,
  variant: PropTypes.string,
};

SelectGroupComponent.defaultProps = {
  change: () => {},
  disableMargin: false,
  error: false,
  helperText: '',
  id: '',
  name: '',
  placeholder: '',
  text: '',
  variant: 'outlined',
};

export default function SelectGroupComponent({
  change,
  disableMargin,
  error,
  helperText,
  groups,
  id,
  name,
  placeholder,
  text,
  value,
  variant,
}) {
  const inputLabel = useRef(null);

  const createGroups = (groupDates) =>
    groupDates.map((group, groupIndex) => (
      <optgroup key={groupIndex} label={group.name}>
        {group.dates.map((date, index) => (
          <option key={groupIndex + index} value={date.value}>
            {date.text}
          </option>
        ))}
      </optgroup>
    ));

  return (
    <FormControl
      fullWidth
      error={error}
      variant={variant}
      sx={{ margin: disableMargin ? 0 : 1 }}
    >
      <InputLabel shrink ref={inputLabel} htmlFor={id}>
        <Typography color="textPrimary" variant="subtitle1">
          <Box letterSpacing={0} lineHeight={1.1} mt="2px">
            {text}
          </Box>
        </Typography>
      </InputLabel>

      <Select
        error={error}
        id={id}
        label={text}
        name={name}
        native
        onChange={(event) => change(event.target.value)}
        value={value != null ? value : ''}
      >
        {placeholder && (
          <option defaultValue disabled value={0}>
            {placeholder}
          </option>
        )}
        {createGroups(groups)}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
